// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { FormControl } from '@angular/forms';
import { DomainValidator } from './domain-validator';

/**
 * Angular form validator for company domain validation.
 * Uses DomainValidator internally for the actual validation logic.
 *
 * @param domainAlias - Comma-separated list of domain aliases (e.g., "alias1.com,alias2.com")
 * @param domains - Comma-separated list of primary domains (e.g., "example.com,test.com")
 * @returns Angular ValidatorFn that returns { orgDomainAlias: true } on error, null on success
 */
export const orgDomainAliasValidator =
  (
    domainAlias: string | null | undefined,
    domains: string | null | undefined = ''
  ) =>
  (control: FormControl) => {
    if (!control.value) {
      return null;
    }

    const isValid = DomainValidator.isCompanyDomain(
      control.value,
      domains,
      domainAlias
    );

    return isValid ? null : { orgDomainAlias: true };
  };
